import React, { useState } from "react";
import styles from "./DeleteCity.module.css";
import { API } from "../../../core/api";
import { Note } from "../../../components/Note";
import Input from "antd/lib/input/Input";

const DeleteCity = (props) => {
  const { data, getEmployees } = props;
  const [searchCity, setSearchCity] = useState("");

  const onRemoveCity = (city_id) => {
    // API.put
    //   .put_company_employee({
    //     company_employee_id: data.user.id,
    //     city_id: `${city_id}`,
    //   })
    //   .then((response) => {
    //     if (response.success) {
    //       Note.success(response.message);
    //       getEmployees();
    //     } else {
    //       Note.error(response.message);
    //     }
    //   });
  };

  return (
    <>
      <h3 className={styles.DeleteCityTitle}>Current Cities</h3>
      <Input
        placeholder="Search City"
        value={searchCity}
        className={styles.DeleteCitySearchInput}
        onChange={(e) => setSearchCity(e.target.value.trim())}
      />
      <div className={styles.DeleteCityList}>
        {data.cities
          .filter((city) => city.name.includes(searchCity))
          .map((city) => {
            return (
              <div key={city.id} className={styles.DeleteCityItem}>
                <span>{city.name}</span>

                <div
                  className={styles.DeleteCityIcon}
                  onClick={() => onRemoveCity(city.id)}
                >
                  <i
                    class="fa fa-trash"
                    style={{ color: "red" }}
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default DeleteCity;
